export const STEP_FRAME_LEFT = "STEP_FRAME_LEFT";
export const STEP_FRAME_RIGHT = "STEP_FRAME_RIGHT";
export const SET_ACTIVE_SERIES_AND_FRAME = "SET_ACTIVE_SERIES_AND_FRAME";
export const SET_ACTIVE_VIEW_INDEX = "SET_ACTIVE_VIEW_INDEX";
export const TRIGGER_PREFERRED_ANGLE = "TRIGGER_PREFERRED_ANGLE";
export const RESOLUTION_CHANGED = "RESOLUTION_CHANGED";
